// This ONSA configuration should only be changed for conducting pilot rollout of ONSA on production.
// The list of products below should not be changed otherwise.
// If all products need to be shown (ie. on test environments), ONSA_PILOT_ENABLED should be set to false.
const ONSA_PILOT_ENABLED = true;
const ONSA_PILOT_LOBS = [
    'dog',
    'cat',
    'travel',
    'accident',
    'youngAccident',
    'childAccident',
    'privateContent',
    'youthContent',
    'trailer',
    'caravan',
    'car'
];

const SHOW_UNSUPPORTED_ONSA_PRODUCTS = false;

export { ONSA_PILOT_ENABLED, ONSA_PILOT_LOBS, SHOW_UNSUPPORTED_ONSA_PRODUCTS };
